import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { finalize, switchMap } from 'rxjs';
import { DialogManager } from '../../../../global/dialog-manager/dialog';
import { Loader } from '../../../../global/loader';
import { PostCode } from '../../../../global/postcode';
import { SkeletonLoaderComponent } from '../../../../shared/components/skeleton-loader/skeleton-loader.component';
import { UnavailableDocumentsComponent } from '../../../../shared/components/unavailable-documents/unavailable-documents.component';
import { PlanDocumentsService } from '../../../../shared/services/plan-document.service';
import { MmrService } from '../../services/mmr.service';
import { claimsTrackerFeedbackConfig } from './claims-details-feedback.config';
import { CreateBookingComponent } from './components/create-booking/create-booking.component';
import { ErrorLoadingDetailsComponent } from './components/error-loading-details/error-loading-details.component';
import { InWaitComponent } from './components/in-wait/in-wait.component';
import { InWarrantyComponent } from './components/in-warranty/in-warranty.component';
import { NoAllocationRulesComponent } from './components/no-allocation-rules/no-allocation-rules.component';
import { NotForOnlineComponent } from './components/not-for-online/not-for-online.component';
import { ResumeBookingComponent } from './components/resume-booking/resume-booking.component';
import { RpcComponent } from './components/rpc/rpc.component';
import { UnknownComponent } from './components/unknown/unknown.component';
import { ViewClaimComponent } from './components/view-claim/view-claim.component';
import { ViewPrOfferComponent } from './components/view-pr-offer/view-pr-offer.component';

@Component({
  selector: 'app-claim-details',
  standalone: true,
  imports: [
    UnknownComponent,
    CreateBookingComponent,
    ResumeBookingComponent,
    SkeletonLoaderComponent,
    InWarrantyComponent,
    ErrorLoadingDetailsComponent,
    ViewClaimComponent,
    ViewPrOfferComponent,
    InWaitComponent,
    RpcComponent,
    NotForOnlineComponent,
    NoAllocationRulesComponent,
  ],
  templateUrl: './claim-details.component.html',
  styleUrl: './claim-details.component.scss',
  host: {
    class: 'p-24 md-p-16',
  },
})
export class ClaimDetailsComponent {
  private readonly planDocumentsService = inject(PlanDocumentsService);
  claimType = input.required<'repair' | 'service'>();

  callCostMessaging = signal<string>('');

  private viewModel = computed(() => {
    const { claims } = this.mmrService.planClaimsDetails;
    // const repairData = repair.value();
    // const repairDetails = repairData?.repairDetails as InProgressRepairDetails | undefined;
    // const slowTriggered = this.mmrService.planClaimsDetails.repairSlowLoadTriggered();
    //
    // return {
    //   planNumber: plan.value()?.planId,
    //   callCostMessaging: this.callCostMessaging(),
    //   isLoading: repair.isLoading(),
    //   isError: !!repair.error(),
    //   repair: repairData,
    //   repairDetails,
    //   formattedProviderName:
    //     (repairDetails?.provider?.name || '').charAt(0).toUpperCase() +
    //     (repairDetails?.provider?.name || ' ').slice(1).toLowerCase(),
    //   providerEmail: repairDetails?.provider?.email,
    //   address: repairData?.address?.lines ? [...repairData.address.lines, repairData.address.postalcode] : undefined,
    //   showTimeoutMessage: slowTriggered,
    // };

    return {
      loading: claims.isLoading(),
      claimDetails: claims.value()?.[this.claimType()],
      claimType: this.claimType(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  feedbackConfig = claimsTrackerFeedbackConfig;

  constructor(private readonly mmrService: MmrService) {
    effect(() => {
      // this.getCallCostMessaging(this.vm.repair?.address?.postalcode);
    });
  }

  retry(): void {
    // this.mmrService.reloadRepair();
  }

  getCallCostMessaging(postCode: string | undefined): void {
    if (!postCode) return;

    PostCode.getCallCostMessagingForPostCode(postCode).subscribe({
      next: (messaging) => {
        this.callCostMessaging.set(messaging);
      },
    });
  }

  downloadPlanDocs() {
    const planNumber = this.mmrService.planNumber();
    if (!planNumber) return;

    Loader.showLoader();
    this.planDocumentsService
      .searchPlanDocumentKey(planNumber)
      .pipe(
        switchMap((planDocumentKey) => this.planDocumentsService.downloadPlanDocument(planNumber, planDocumentKey)),
        finalize(() => Loader.hideLoader())
      )
      .subscribe({
        error: () => {
          DialogManager.openDialog(UnavailableDocumentsComponent);
        },
      });
  }
}
